/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { user2faUrl, userAuditLogsUrl, userProfileUrl, userSelectedProfileUrl } from 'common/config/urls';
import { ACCOUNT_SETTINGS_TAB, AUDIT_LOGS_TAB, TWO_FACTOR_AUTH_TAB } from 'common/constants/user';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import LayoutContext from 'context/LayoutContext';
import { AuditLogs as AuditLogsView, User2FA as User2FAView, UserProfile as UserProfileView } from 'pages';
import { UserParams } from 'pages/UserProfile/types';

const UserContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [{ firmInfo }] = useStore() as unknown as UseStoreValues;
  const { userIdParam } = useParams<UserParams>();
  const [accountSettingsUrl, setAccountSettingsUrl] = useState('');
  const [otpUrl, setOtpUrl] = useState('');
  const [auditLogsUrl, setAuditLogsUrl] = useState('');
  const { setNavItems } = useContext(LayoutContext);

  const currentPath = useMemo(() => location.pathname.split('/').pop(), [location]);

  useEffect(() => {
    if (firmInfo?.slug) {
      const accountSettingsTabUrl = userIdParam
        ? userSelectedProfileUrl(firmInfo.slug, Number(userIdParam))
        : userProfileUrl(firmInfo.slug);
      setAccountSettingsUrl(accountSettingsTabUrl);

      setOtpUrl(user2faUrl(firmInfo.slug));
      setAuditLogsUrl(userAuditLogsUrl(firmInfo.slug));
    }
  }, [firmInfo, userIdParam]);

  const menuItems = useMemo(() => {
    if (firmInfo?.slug) {
      return [
        {
          callback: () => navigate(accountSettingsUrl),
          id: 'account-settings',
          itemKey: 0,
          slug: 'account-settings',
          title: 'Account Settings',
        },
        {
          callback: () => navigate(otpUrl),
          id: 'two-factor-authentication',
          itemKey: 1,
          slug: 'two-factor-authentication',
          title: 'Two Factor Authentication',
        },
        {
          callback: () => navigate(auditLogsUrl),
          id: AUDIT_LOGS_TAB,
          itemKey: 2,
          slug: AUDIT_LOGS_TAB,
          title: 'Audit Logs',
        },
      ];
    }
    return [];
  }, [firmInfo]);

  useEffect(() => {
    setNavItems?.(menuItems);
    return () => setNavItems?.(null);
  }, [menuItems]);

  const renderCurrentView = () => {
    switch (currentPath) {
      case ACCOUNT_SETTINGS_TAB:
        return <UserProfileView />;
      case TWO_FACTOR_AUTH_TAB:
        return <User2FAView />;
      case AUDIT_LOGS_TAB:
        return <AuditLogsView />;
      default:
        return <p>Hello missing route</p>;
    }
  };

  return <div>{renderCurrentView()}</div>;
};

export default UserContainer;
